/**
 * 首页-》忘记密码
 */


import React, { Component } from 'react';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import ErrorBox from '../../components/Alert/ErrorBox.jsx';

export default class ForgotStep1 extends Component {

  constructor(props) {
    super(props);
    this.state = { accountType: 'phone', reset: false, captchaTimer: null };
    this.getCaptcha = this.getCaptcha.bind(this);
    this.validateMobile = this.validateMobile.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateNext = this.validateNext.bind(this);
    this.checkCaptcha = this.checkCaptcha.bind(this);
    this.chooseAccountType = this.chooseAccountType.bind(this);

  }

  render() {
    const { captchaTimer = 0, reset } = this.props,
      getCaptchaText = captchaTimer ? `${captchaTimer} ${getLang('RETRY_CAPTCHA')}` : getLang('GET_CAPTCHA'),
      captchaDisabled = !!captchaTimer && !reset;
    this.state.captchaTimer = captchaTimer;
    //console.log(captchaTimer);
    //console.log(this.state.captchaTimer);
    return (
      <div className='login-forgot-page'>
        <form ref='captchaForm' className='login-forgot-form'>
          <input type="hidden" ref="type" name="type" id="type" />
          <div className='form-control form-control-radio' >
            <input type="radio" ref='accountTypePhone' name='accountType' defaultChecked={true} onChange={this.chooseAccountType} value='phone' />手机 <input type="radio" ref='accountTypeEmail' name='accountType' onChange={this.chooseAccountType} value='email' />邮箱
          </div>
          <FormControl label={getLang('COMPANY')} tips={getLang('REQUIRED')}>
            <TextInput ref='companyCode' id='companyCode' name='companyCode'
              type='text' required
              onChange={this.validateMobile} />
          </FormControl>
          <FormControl label={getLang('MOBILE')} tips={getLang('REQUIRED')} type={this.state.accountType == 'phone' ? 'block' : 'hidden'}>
            <TextInput ref='phone' id='phone' name='phone'
              type='tel' required
              onChange={this.validateMobile} onBlur={this.validateMobile} />
          </FormControl>
          <FormControl label={getLang('EMAIL')} tips={getLang('REQUIRED')} type={'hidden'} type={this.state.accountType == 'email' ? 'block' : 'hidden'}>
            <TextInput ref='email' id='email' name='email'
              type='email' required
              onChange={this.validateMobile} onBlur={this.validateEmail} />
          </FormControl>
          <FormControl label={getLang('CAPTCHA')} tips={getLang('REQUIRED')}>
            <TextInput id='captcha' name='captcha' ref='captcha' required onChange={this.validateNext} />
          </FormControl>

          <Button ref='getCaptcha'
            className='login-get-captcha' text={getCaptchaText} link
            onTouchTap={captchaDisabled?function(){}:this.getCaptcha} />
          <input type='hidden' ref='accountType' />
        </form>
        <ErrorBox ref='errorBox' />
        <Button ref='next'
          className='login-reset-pwd' text={getLang('NEXT')}
          onTouchTap={this.checkCaptcha} disabled />
      </div>
    );
  }

  /**
   * choose account type (phone or email)
   * 
   * @memberof event
   */
  chooseAccountType(e) {
    if (e.target.value == 'phone') {
      React.findDOMNode(this.refs.accountTypePhone).checked = 'checked';
      React.findDOMNode(this.refs.email).value = '1@1.com'; //test
      this.setState({ accountType: 'phone' });
    } else {
      var email = React.findDOMNode(this.refs.accountTypeEmail);
      email.checked = 'checked';
      React.findDOMNode(this.refs.phone).value = '15800000000'; //test
      this.setState({ accountType: 'email' });
    }
  }

  /**
   *  验证邮箱
   */
  validateEmail() {
    const item = React.findDOMNode(this.refs.email).value;
    let matchEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})$/;
    let emailValid = matchEmail.test(item);

    if (!emailValid) {
      this.refs.errorBox.setState({ message: '邮箱格式有误' });
      return false;
    }
    this.refs.errorBox.setState({ message: '' });
    return true;
  }

  /**
  * 验证手机号
  */

  validateMobile() {
    const item = React.findDOMNode(this.refs.phone).value;

    let mobileValid = true;
    let emailValid = true;
    //check mobile
    if (item.length < 11) {
      mobileValid = false;
    }

    if (!mobileValid) {
      this.refs.errorBox.setState({ message: '手机号格式有误' });
      return false;
    }
    this.refs.errorBox.setState({ message: '' });
    return true;
  }

  /**
   * Get captcha
   */
  getCaptcha() {
    //const { captchaTimer = 100 } = this.props;
    //alert(this.refs.errorBox)
    //console.log(this.props.captchaTimer);
    //console.log(this.state.captchaTimer);
    // if(this.state.captchaTimer == undefined)
    //     this.state.captchaTimer = 1;
    //console.log(captchaTimer);
    if (this.props.captchaTimer == null || this.props.captchaTimer == 0) {
      //if (captchaTimer != 100) {
        if (this.state.accountType == 'phone') {
          if (this.validateMobile()) {
            dispatch({
              type: 'get-captcha',
              data: {
                type: this.state.accountType,
                email: React.findDOMNode(this.refs.email).value,
                phone: React.findDOMNode(this.refs.phone).value,
                companyCode: React.findDOMNode(this.refs.companyCode).value
              }
            });
          }
        } else {
          if (this.validateEmail()) {
            dispatch({
              type: 'get-captcha',
              data: {
                type: this.state.accountType,
                email: React.findDOMNode(this.refs.email).value,
                phone: React.findDOMNode(this.refs.phone).value,
                companyCode: React.findDOMNode(this.refs.companyCode).value
              }
            });
          }
        }
      //}
      //console.log('能');
    } else {
      //console.log('不能');
    }
  }


  /**
   * Check if can go to next step
   * @param e
   */
  validateNext(e) {
    const captcha = e.target.value,
      valid = (this.validateMobile() && captcha && captcha.length);

    React.findDOMNode(this.refs.next).disabled = !valid;

    return valid;
  }


  /**
   * Check captcha before resetting password
   */
  checkCaptcha() {
    if (React.findDOMNode(this.refs.captcha).value == '') {
      this.refs.errorBox.setState({ message: 'Please enter the verification code' });
    } else {
      this.refs.errorBox.setState({ message: '' });
      React.findDOMNode(this.refs.type).value = this.state.accountType;
      if (this.state.accountType == 'phone') {
        React.findDOMNode(this.refs.type).value = 1;
      } else {
        React.findDOMNode(this.refs.type).value = 2;
      }

      var form = new FormData(React.findDOMNode(this.refs.captchaForm));
      form.accountType = React.findDOMNode(this.refs.type).value;
      dispatch({
        type: 'check-captcha',
        data: form
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/containers/Login/ForgotStep1.jsx